import { memo, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import {
  bsaBmiCalculation,
  checkDoctorDept,
  defaultGeneralData,
} from '../../../utils/helpers';
import GeneralExaminationBtn from '../partials/generalExaminationBtn';

const GeneralExamination = ({
  selectedOnExamination,
  handleOnExaminationData,
}) => {
  let { generalExaminations } = selectedOnExamination;
  generalExaminations = generalExaminations || defaultGeneralData();
  const [fieldName, setFieldName] = useState('');
  const [isGeneralExaminationBtn, setIsGeneralExaminationBtn] = useState(false);
  const [btnInputArray, setBtnInputArray] = useState([]);
  const userInfo = useSelector((state) => state.authReducer.data);
  const specialties = useSelector(
    (state) => state.specialtyReducer.specialties,
  );
  const isPediatric = checkDoctorDept(
    'pediatrics',
    userInfo?.speciality[0],
    specialties,
  );

  const handleGeneralExamination = (field, value) => {
    const updatedData = { ...generalExaminations };

    const updatePulseInfo = () => {
      updatedData.pulseInfo[field] =
        field === 'pulseType' && updatedData.pulseInfo[field] === value
          ? ''
          : value;
    };

    const updateTemperatureInfo = () => {
      updatedData.temperatureInfo[field] =
        field === 'temperatureType' && updatedData.temperatureInfo[field]
          ? ''
          : value;
    };

    const updateWeightOrHeight = (type) => {
      updatedData[type][field] = value;
      if (type === 'heightInfo' && value === 'Cm')
        updatedData.heightInfo.inch = '';

      const { bsa, bmi } = bsaBmiCalculation(
        updatedData.heightInfo.feet,
        updatedData.heightInfo.inch,
        updatedData.heightInfo.heightUnit,
        updatedData.weightInfo.weight,
        updatedData.weightInfo.weightUnit,
      );

      updatedData.bsa = bsa ? bsa.toFixed(2) : '';
      updatedData.bmi = bmi ? bmi.toFixed(2) : '';
    };

    switch (field) {
      case 'systolic':
      case 'diastolic':
        updatedData.bloodPressure[field] = value;
        break;

      case 'pulse':
      case 'pulseUnit':
      case 'pulseType':
      case 'note':
        updatePulseInfo();
        break;

      case 'temperature':
      case 'temperatureUnit':
      case 'temperatureType':
        updateTemperatureInfo();
        break;

      case 'weight':
      case 'weightUnit':
      case 'hideWeight':
        updateWeightOrHeight('weightInfo');
        break;

      case 'feet':
      case 'inch':
      case 'heightUnit':
      case 'hideHeight':
        updateWeightOrHeight('heightInfo');
        break;

      case 'showBsa':
      case 'showBmi':
        updatedData[field] = !value;
        break;

      case 'idealWeight':
      case 'idealWeightUnit':
        updatedData.idealWeightInfo[field] = value;
        break;

      default:
        updatedData[field] = value;
        break;
    }
    console.log(updatedData, 'updatedData');
    handleOnExaminationData(updatedData, 'generalExamination');
    setIsGeneralExaminationBtn(false);
  };

  const btnStyle = {
    marginRight: '20px',
    width: '20%',
  };

  const handleBtnInputArray = (field) => {
    setFieldName(field);
    let buttonArray;
    if (field === 'systolic') {
      buttonArray = [
        70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200,
      ];
    } else if (field === 'diastolic') {
      buttonArray = [40, 50, 60, 70, 80, 90, 100, 110, 120];
    } else if (field === 'pulse') {
      buttonArray = [
        40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120,
      ];
    } else if (field === 'temperature') {
      buttonArray = [
        '95°',
        '96°',
        '97°',
        '98°',
        '99°',
        '100°',
        '101°',
        '102°',
        '103°',
        '104°',
        '105°',
      ];
    } else if (field === 'weight') {
      isPediatric
        ? (buttonArray = [2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 25, 30, 35])
        : (buttonArray = [
            40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115,
            120,
          ]);
    } else if (field === 'feet') {
      buttonArray = [1, 2, 3, 4, 5, 6, 7];
    } else if (field === 'inch') {
      buttonArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    } else if (field === 'idealWeight') {
      isPediatric
        ? (buttonArray = [1, 2, 3, 4, 5, 6, 7])
        : (buttonArray = [40, 45, 50, 55, 60, 65, 70, 75, 80]);
    }
    setIsGeneralExaminationBtn(isGeneralExaminationBtn ? false : true);
    setBtnInputArray(buttonArray);
  };

  // const handleGeneralExamination = (fieldName, val) => {
  //   if (fieldName === 'systolic' || fieldName === 'diastolic') {
  //     generalExaminations.bloodPressure[fieldName] = val;
  //   } else if (
  //     fieldName === 'pulse' ||
  //     fieldName === 'pulseUnit' ||
  //     fieldName === 'pulseType'
  //   ) {
  //     if (fieldName === 'pulseType') {
  //       generalExaminations.pulseInfo[fieldName] =
  //         generalExaminations.pulseInfo[fieldName] === val ? '' : val;
  //     } else {
  //       generalExaminations.pulseInfo[fieldName] = val;
  //     }
  //   } else if (fieldName === 'temperature' || fieldName === 'temperatureUnit') {
  //     generalExaminations.temperatureInfo[fieldName] = val;
  //   } else if (fieldName === 'temperatureType') {
  //     generalExaminations.temperatureInfo[fieldName] = generalExaminations
  //       .temperatureInfo[fieldName]
  //       ? ''
  //       : val;
  //   } else if (
  //     fieldName === 'weight' ||
  //     fieldName === 'weightUnit' ||
  //     fieldName === 'weightShowInPrescription'
  //   ) {
  //     generalExaminations.weightInfo[fieldName] = val;
  //     const result = bsaBmiCalculation(
  //       generalExaminations.heightInfo.feet,
  //       generalExaminations.heightInfo.inch,
  //       generalExaminations.heightInfo.heightUnit,
  //       generalExaminations.weightInfo.weight,
  //       generalExaminations.weightInfo.weightUnit,
  //     );
  //     generalExaminations['bsa'] = result?.bsa ? result?.bsa?.toFixed(2) : '';
  //     generalExaminations['bmi'] = result?.bmi ? result?.bmi?.toFixed(2) : '';
  //   } else if (
  //     fieldName === 'feet' ||
  //     fieldName === 'inch' ||
  //     fieldName === 'heightUnit' ||
  //     fieldName === 'heightShowInPrescription'
  //   ) {
  //     generalExaminations.heightInfo[fieldName] = val;
  //     if (val === 'Cm') {
  //       generalExaminations.heightInfo.inch = '';
  //     }
  //     const result = bsaBmiCalculation(
  //       generalExaminations.heightInfo.feet,
  //       generalExaminations.heightInfo.inch,
  //       generalExaminations.heightInfo.heightUnit,
  //       generalExaminations.weightInfo.weight,
  //       generalExaminations.weightInfo.weightUnit,
  //     );
  //     generalExaminations['bsa'] = result.bsa ? result.bsa.toFixed(2) : '';
  //     generalExaminations['bmi'] = result.bmi ? result.bmi.toFixed(2) : '';
  //   } else if (fieldName === 'showBsa' || fieldName === 'showBmi') {
  //     generalExaminations[fieldName] = val ? false : true;
  //   } else if (fieldName === 'idealWeight' || fieldName === 'idealWeightUnit') {
  //     generalExaminations.idealWeightInfo[fieldName] = val;
  //   } else {
  //     generalExaminations[fieldName] = val;
  //   }
  //   handleOnExaminationData(generalExaminations, 'generalExamination');
  //   setIsGeneralExaminationBtn(false);
  // };

  return (
    <div className="general-examination">
      <Form.Group as={Row}>
        <Col sm="3">
          <Form.Label column className="font-weight-bold">
            B. Pressure:
          </Form.Label>
        </Col>
        <Col sm="3">
          <Form.Control
            className="form-control-sm"
            type="number"
            value={generalExaminations?.bloodPressure?.systolic}
            defaultValue={generalExaminations?.bloodPressure?.systolic}
            placeholder="Systolic"
            onClick={() => handleBtnInputArray('systolic')}
            onChange={(e) =>
              handleGeneralExamination('systolic', e.target.value)
            }
          />
        </Col>
        <Col sm="1">
          <span
            className="line"
            style={{
              width: '30px',
              borderBottom: '1px solid #4e73df',
              transform: `translateY(15px)
                            translateX(2px)
                            rotate(110deg)`,
              position: 'absolute',
              bottom: '10px',
            }}
          ></span>
        </Col>
        <Col sm="3">
          <Form.Control
            className="form-control-sm"
            type="number"
            value={generalExaminations?.bloodPressure?.diastolic}
            defaultValue={generalExaminations?.bloodPressure?.diastolic}
            placeholder="Diastolic"
            onClick={() => handleBtnInputArray('diastolic')}
            onChange={(e) =>
              handleGeneralExamination('diastolic', e.target.value)
            }
          />
        </Col>
        <Col sm="2" className="pt-2">
          <span>mmHg</span>
        </Col>
      </Form.Group>
      {isGeneralExaminationBtn &&
        (fieldName === 'systolic' || fieldName === 'diastolic') && (
          <Row>
            <Col md={fieldName === 'diastolic' ? 6 : 3}></Col>
            <Col md={fieldName === 'diastolic' ? 5 : 9}>
              <GeneralExaminationBtn
                fieldName={fieldName}
                btnInputArray={btnInputArray}
                onClickAction={handleGeneralExamination}
              />
            </Col>
          </Row>
        )}
      <Form.Group as={Row} className="mt-2 align-items-center">
        {/* Label */}
        <Col xs={12} sm={3}>
          <Form.Label column className="font-weight-bold mb-1 mb-sm-0">
            Pulse:
          </Form.Label>
        </Col>

        {/* Pulse Input */}
        <Col xs={6} sm={2} md={1} className="pr-sm-0 mb-2 mb-sm-0">
          <Form.Control
            className="form-control-sm"
            type="text"
            value={generalExaminations?.pulseInfo?.pulse || ''}
            placeholder="Pulse"
            onClick={() => handleBtnInputArray('pulse')}
            onChange={(e) => handleGeneralExamination('pulse', e.target.value)}
          />
        </Col>

        {/* Unit Select */}
        <Col xs={6} sm={2} md={1} className="pr-sm-0 mb-2 mb-sm-0">
          <Form.Select
            className="form-control form-control-sm"
            value={generalExaminations?.pulseInfo?.pulseUnit || ''}
            onChange={(e) =>
              handleGeneralExamination('pulseUnit', e.target.value)
            }
          >
            <option value="PM">PM</option>
            <option value="BPM">BPM</option>
          </Form.Select>
        </Col>

        {/* Buttons */}
        <Col xs={12} sm={5} md={4} className="mb-2 pt-2 mb-sm-0">
          {['Normal', 'Regular', 'Irregular', 'Drop Beat'].map((type) => (
            <Button
              key={type}
              variant={
                generalExaminations?.pulseInfo?.pulseType === type
                  ? 'primary'
                  : 'outline-secondary'
              }
              size="sm"
              className="pulse-btn mr-1 mb-1"
              onClick={() => handleGeneralExamination('pulseType', type)}
            >
              {type}
            </Button>
          ))}
        </Col>

        {/* Note Input */}
        <Col xs={12} sm={2} md={3} className="pl-sm-0">
          <Form.Control
            className="form-control-sm"
            type="text"
            value={generalExaminations?.pulseInfo?.note || ''}
            placeholder="Note"
            onChange={(e) => handleGeneralExamination('note', e.target.value)}
          />
        </Col>
      </Form.Group>

      {isGeneralExaminationBtn && fieldName === 'pulse' && (
        <Row>
          <Col md={2}></Col>
          <Col md={10}>
            <GeneralExaminationBtn
              fieldName={fieldName}
              btnInputArray={btnInputArray}
              onClickAction={handleGeneralExamination}
            />
          </Col>
        </Row>
      )}
      <Form.Group as={Row} className="mt-2">
        <Col sm="3" className="pr-0">
          <Form.Label column className="font-weight-bold">
            Respiratory Rate (RR):
          </Form.Label>
        </Col>
        <Col sm="4">
          <Form.Control
            className="form-control-sm"
            type="number"
            value={generalExaminations?.respiratoryRate}
            defaultValue={generalExaminations?.respiratoryRate}
            placeholder="Respiratory Rate (RR)"
            onChange={(e) =>
              handleGeneralExamination('respiratoryRate', e.target.value)
            }
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="mt-2">
        <Col sm="3">
          <Form.Label column className="font-weight-bold">
            Temperature:
          </Form.Label>
        </Col>
        <Col sm="2">
          <Form.Control
            className="form-control-sm"
            type="text"
            value={generalExaminations.temperatureInfo.temperature}
            defaultValue={generalExaminations.temperatureInfo.temperature}
            placeholder="Temperature"
            onClick={() => handleBtnInputArray('temperature')}
            onChange={(e) =>
              handleGeneralExamination('temperature', e.target.value)
            }
          />
        </Col>
        <Col md="2">
          <Form.Select
            className="form-control form-control-sm"
            defaultValue={generalExaminations.temperatureInfo.temperatureUnit}
            onChange={(e) =>
              handleGeneralExamination('temperatureUnit', e.target.value)
            }
          >
            <option value="F">
              <span>&#8457;</span>
            </option>
            <option value="C">
              <span>&#8451;</span>
            </option>
            <option value="K">K</option>
          </Form.Select>
        </Col>
        <Col sm="2">
          <Button
            style={{ marginTop: '5px' }}
            variant={
              generalExaminations.temperatureInfo.temperatureType === 'Normal'
                ? 'primary'
                : 'outline-secondary'
            }
            size="sm"
            className="mr-2"
            onClick={(e) =>
              handleGeneralExamination('temperatureType', 'Normal')
            }
          >
            Normal
          </Button>
        </Col>
      </Form.Group>
      {isGeneralExaminationBtn && fieldName === 'temperature' && (
        <Row>
          <Col md={3}></Col>
          <Col md={9}>
            <GeneralExaminationBtn
              fieldName={fieldName}
              btnInputArray={btnInputArray}
              onClickAction={handleGeneralExamination}
            />
          </Col>
        </Row>
      )}
      <Form.Group as={Row} className="mt-2">
        <Col sm="3">
          <Form.Label column className="font-weight-bold">
            Weight:
          </Form.Label>
        </Col>
        <Col sm="2">
          <Form.Control
            className="form-control-sm"
            type="text"
            value={generalExaminations.weightInfo.weight}
            defaultValue={generalExaminations.weightInfo.weight}
            placeholder="Weight"
            onClick={() => handleBtnInputArray('weight')}
            onChange={(e) => handleGeneralExamination('weight', e.target.value)}
          />
        </Col>
        <Col md="2">
          <Form.Select
            className="form-control form-control-sm"
            value={generalExaminations.weightInfo.weightUnit}
            defaultValue={generalExaminations.weightInfo.weightUnit}
            onChange={(e) =>
              handleGeneralExamination('weightUnit', e.target.value)
            }
          >
            <option value="KG">KG</option>
            <option value="Pound">Pound</option>
          </Form.Select>
        </Col>
        <Col sm="2" className="pt-1 pr-0">
          <Form.Check
            type={`checkbox`}
            id={`weight_show_in_prescription`}
            style={{ fontSize: '15px' }}
            label={`Hide in Rx`}
            checked={generalExaminations?.weightInfo?.hideWeight}
            onChange={(e) =>
              handleGeneralExamination('hideWeight', e.target.checked)
            }
          />
        </Col>
        <Col sm="3">
          <Button
            size="sm"
            style={{ minWidth: '78px' }}
            variant={
              generalExaminations.showBmi ? 'primary' : 'outline-secondary'
            }
            onClick={() =>
              handleGeneralExamination('showBmi', generalExaminations.showBmi)
            }
          >
            {generalExaminations.showBmi ? 'Hide' : 'Show'} BMI
          </Button>
          <span className="ml-3 font-weight-bold">
            {generalExaminations.bmi}
          </span>
        </Col>
      </Form.Group>
      {isGeneralExaminationBtn && fieldName === 'weight' && (
        <Row>
          <Col md={3}></Col>
          <Col md={9}>
            <GeneralExaminationBtn
              fieldName={fieldName}
              btnInputArray={btnInputArray}
              onClickAction={handleGeneralExamination}
            />
          </Col>
        </Row>
      )}
      <Form.Group as={Row} className="mt-2">
        <Col sm="3">
          <Form.Label column className="font-weight-bold">
            Height:
          </Form.Label>
        </Col>
        <Col sm="1" className="pr-0">
          <Form.Control
            className="form-control-sm"
            value={generalExaminations.heightInfo.feet}
            defaultValue={generalExaminations.heightInfo.feet}
            type="text"
            placeholder="Feet"
            onClick={() => handleBtnInputArray('feet')}
            onChange={(e) => handleGeneralExamination('feet', e.target.value)}
          />
        </Col>
        <Col sm="1">
          <Form.Control
            className="form-control-sm"
            value={generalExaminations.heightInfo.inch}
            defaultValue={generalExaminations.heightInfo.inch}
            type="text"
            disabled={
              generalExaminations.heightInfo.heightUnit === 'Cm' ? true : false
            }
            placeholder="Inch"
            onClick={() => handleBtnInputArray('inch')}
            onChange={(e) => handleGeneralExamination('inch', e.target.value)}
          />
        </Col>
        <Col md="2">
          <Form.Select
            className="form-control form-control-sm"
            defaultValue={generalExaminations.heightInfo.heightUnit}
            onChange={(e) =>
              handleGeneralExamination('heightUnit', e.target.value)
            }
          >
            <option value="Ft">Ft</option>
            <option value="Cm">Cm</option>
          </Form.Select>
        </Col>
        <Col md="2" className="pt-1 pr-0">
          <Form.Check
            type={`checkbox`}
            style={{ fontSize: '15px' }}
            id={`height_show_in_prescription`}
            label={`Hide in Rx`}
            checked={generalExaminations?.heightInfo?.hideHeight}
            onChange={(e) =>
              handleGeneralExamination('hideHeight', e.target.checked)
            }
          />
        </Col>
        <Col sm="3">
          <Button
            size="sm"
            style={{ minWidth: '78px' }}
            variant={
              generalExaminations.showBsa ? 'primary' : 'outline-secondary'
            }
            onClick={() =>
              handleGeneralExamination('showBsa', generalExaminations.showBsa)
            }
          >
            {generalExaminations.showBsa ? 'Hide' : 'Show'} BSA
          </Button>
          <span className="ml-3 font-weight-bold">
            {generalExaminations.bsa}
          </span>
        </Col>
      </Form.Group>
      {isGeneralExaminationBtn &&
        (fieldName === 'feet' || fieldName === 'inch') && (
          <Row>
            <Col md={3}></Col>
            <Col md={9}>
              <GeneralExaminationBtn
                fieldName={fieldName}
                btnInputArray={btnInputArray}
                onClickAction={handleGeneralExamination}
              />
            </Col>
          </Row>
        )}
      <Form.Group as={Row} className="mt-2">
        <Col sm="3" className="pr-0">
          <Form.Label column className="font-weight-bold">
            Activity Level:
          </Form.Label>
        </Col>
        <Col sm="4">
          <Form.Select
            className="form-control form-control-sm"
            defaultValue={generalExaminations?.activityLevel}
            onChange={(e) =>
              handleGeneralExamination('activityLevel', e.target.value)
            }
          >
            <option value="">Select Activity Level</option>
            <option value="Sedentary">Sedentary</option>
            <option value="Light Active">Light Active</option>
            <option value="Moderately Active">Moderately Active</option>
            <option value="Overy Active">Overy Active</option>
            <option value="Extra Active">Extra Active</option>
          </Form.Select>
        </Col>
        <Col md="2" className="pt-1"></Col>
        <Col sm="3">
          <Button
            size="sm"
            style={{ minWidth: '78px' }}
            variant={
              generalExaminations.showBmr ? 'primary' : 'outline-secondary'
            }
            onClick={() =>
              handleGeneralExamination('showBmr', generalExaminations.showBmr)
            }
          >
            {generalExaminations.showBmr ? 'Hide' : 'Show'} BMR
          </Button>
          <span className="ml-3 font-weight-bold">
            {generalExaminations.bmr}
          </span>
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mt-2">
        <Col sm="3">
          <Form.Label column className="font-weight-bold">
            Ideal Weight:
          </Form.Label>
        </Col>
        <Col sm="2">
          <Form.Control
            className="form-control-sm"
            type="text"
            value={generalExaminations?.idealWeightInfo?.idealWeight}
            defaultValue={generalExaminations?.idealWeightInfo?.idealWeight}
            placeholder="Ideal Height"
            onClick={() => handleBtnInputArray('idealWeight')}
            onChange={(e) =>
              handleGeneralExamination('idealWeight', e.target.value)
            }
          />
        </Col>
        <Col md="2">
          <Form.Select
            className="form-control form-control-sm"
            value={generalExaminations?.idealWeightInfo?.idealWeightUnit}
            defaultValue={generalExaminations?.idealWeightInfo?.idealWeightUnit}
            onChange={(e) =>
              handleGeneralExamination('idealWeightUnit', e.target.value)
            }
          >
            <option value="KG">KG</option>
            <option value="Pound">Pound</option>
          </Form.Select>
        </Col>
        <Col md="2" className="pt-1"></Col>
        <Col sm="3">
          <Button
            size="sm"
            style={{ minWidth: '78px' }}
            variant={
              generalExaminations.showTdee ? 'primary' : 'outline-secondary'
            }
            onClick={() =>
              handleGeneralExamination('showTdee', generalExaminations.showTdee)
            }
          >
            {generalExaminations.showTdee ? 'Hide' : 'Show'} TDEE
          </Button>
          <span className="ml-3 font-weight-bold">
            {generalExaminations.tdee}
          </span>
        </Col>
      </Form.Group>
      {isGeneralExaminationBtn && fieldName === 'idealWeight' && (
        <Row>
          <Col md={3}></Col>
          <Col md={9}>
            <GeneralExaminationBtn
              fieldName={fieldName}
              btnInputArray={btnInputArray}
              onClickAction={handleGeneralExamination}
            />
          </Col>
        </Row>
      )}
      <Form.Group as={Row} className="mt-2 mb-2">
        <Col sm="3">
          <Form.Label column className="font-weight-bold">
            Ideal BMI:
          </Form.Label>
        </Col>
        <Col sm="4">
          <Form.Control
            className="form-control-sm"
            type="text"
            placeholder="Ideal BMI"
            defaultValue={generalExaminations.idealBmi}
            onChange={(e) =>
              handleGeneralExamination('idealBmi', e.target.value)
            }
          />
        </Col>
        <Col sm="1" className="pt-2">
          Cal
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="mt-2 mb-2">
        <Col sm="3">
          <Form.Label column className="font-weight-bold">
            Target Daily Cal:
          </Form.Label>
        </Col>
        <Col sm="4">
          <Form.Control
            className="form-control-sm"
            type="text"
            placeholder="Target daily cal"
            value={generalExaminations.targetDailyCalory}
            defaultValue={generalExaminations.targetDailyCalory}
            onChange={(e) =>
              handleGeneralExamination('targetDailyCalory', e.target.value)
            }
          />
        </Col>
        <Col sm="1" className="pt-2">
          Cal
        </Col>
      </Form.Group>

      <Form.Group
        as={Row}
        className="mt-2"
        style={{
          backgroundColor: '#f5f5f5',
          marginLeft: '0px',
          marginRight: '0px',
          paddingBottom: '5px',
        }}
      >
        <Col sm="3">
          <Form.Label
            column
            className="font-weight-bold"
            style={{ marginLeft: '-10px' }}
          >
            SpO2:
          </Form.Label>
        </Col>
        <Col sm="4" style={{ marginLeft: '-10px' }}>
          <Form.Control
            className="form-control-sm"
            type="text"
            placeholder="SpO2"
            value={generalExaminations?.spo2}
            defaultValue={generalExaminations?.spo2}
            onChange={(e) => handleGeneralExamination('spo2', e.target.value)}
          />
        </Col>
        <Col sm="1" className="pt-2">
          %
        </Col>
      </Form.Group>

      <Form.Group
        as={Row}
        className="pb-2"
        style={{
          backgroundColor: '#f5f5f5',
          marginLeft: '0px',
          marginRight: '0px',
          paddingBottom: '5px',
        }}
      >
        <Col sm="3">
          <Form.Label
            column
            className="font-weight-bold"
            style={{ marginLeft: '-10px' }}
          >
            SaO2:
          </Form.Label>
        </Col>
        <Col sm="4" style={{ marginLeft: '-10px' }}>
          <Form.Control
            className="form-control-sm"
            type="text"
            placeholder="SaO2"
            value={generalExaminations?.sao2}
            defaultValue={generalExaminations?.sao2}
            onChange={(e) => handleGeneralExamination('sao2', e.target.value)}
          />
        </Col>
        <Col sm="1" className="pt-2">
          %
        </Col>
      </Form.Group>

      <Form.Group
        as={Row}
        className="pb-2"
        style={{
          backgroundColor: '#f5f5f5',
          marginLeft: '0px',
          marginRight: '0px',
          paddingBottom: '5px',
        }}
      >
        <Col sm="3">
          <Form.Label
            column
            className="font-weight-bold"
            style={{ marginLeft: '-10px' }}
          >
            Diabetes:
          </Form.Label>
        </Col>
        <Col sm="8" style={{ marginLeft: '-10px' }}>
          <Button
            size="sm"
            variant={
              generalExaminations.diabetes === 'Yes'
                ? 'primary'
                : 'outline-secondary'
            }
            style={btnStyle}
            onClick={(e) => handleGeneralExamination('diabetes', 'Yes')}
          >
            <i className="fa fa-check" aria-hidden="true"></i>
          </Button>
          <Button
            size="sm"
            variant={
              generalExaminations.diabetes === 'No'
                ? 'primary'
                : 'outline-secondary'
            }
            style={btnStyle}
            onClick={(e) => handleGeneralExamination('diabetes', 'No')}
          >
            <i className="fa fa-ban" aria-hidden="true"></i>
          </Button>
          <Button
            size="sm"
            variant={
              generalExaminations.diabetes === ''
                ? 'primary'
                : 'outline-secondary'
            }
            style={btnStyle}
            onClick={(e) => handleGeneralExamination('diabetes', '')}
          >
            N/A
          </Button>
        </Col>
      </Form.Group>
    </div>
  );
};

export default memo(GeneralExamination);
